<!--
  Shown on /guest* when there is no guest session (expired, logged out, direct
  link): a friendly prompt instead of a 404, with a button that opens the
  global login modal (rendered in LayoutHeader).
-->
<template>
  <div class="container mx-auto px-6 py-16 md:py-24 text-center">
    <span class="inline-block w-16 h-16 rounded-full overflow-hidden border border-neutral-200 mb-6">
      <UiIcon src="/svg/icons/guest-profile-photo.svg" class="w-full h-full" />
    </span>
    <h1 class="text-2xl font-bold text-neutral-800 mb-2">
      <UiLanguagePlaceholder domain="GuestLoginPrompt" name="title" />
    </h1>
    <p class="text-neutral-600 mb-8">
      <UiLanguagePlaceholder domain="GuestLoginPrompt" name="text" />
    </p>
    <UiButton color="petrol" buttonstyle="rounded-xl" buttonpadding="py-3 px-6" @click="open('login')">
      <template #icon>
        <UiIcon src="/svg/icons/person.svg" width="20" height="20" class="fill-white inline-block" />
      </template>
      <UiLanguagePlaceholder domain="GuestLoginPrompt" name="cta" />
    </UiButton>
  </div>
</template>

<script setup lang="ts">
const { open } = useGuestLoginModal()
const { log } = useGuestActivityLog()
onMounted(() => {
  log('guest_prompt_shown', { page: 'guest' })
})
</script>
